/**
 * ProductColorService
 * Service for ProductColor entity operations
 * Route: api/product-colors
 * Controller: ProductColorsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProductColorService
 * Handles product color CRUD operations and filtered queries
 */
export class ProductColorService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProductColorService.DEFAULT_SERVICE_PATH,
            basePath: ProductColorService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== FILTERED LIST ====================
    /**
     * Get all product colors with optional product filter
     * GET /api/product-colors?productId={productId}
     * @param productId - Optional product ID to filter colors
     * @returns Array of product colors
     */
    async getAll(productId) {
        const response = await this.getAllRaw(productId);
        return response.data ?? [];
    }
    /**
     * Get all product colors with optional product filter (raw)
     * @param productId - Optional product ID to filter colors
     * @returns ResponseData with product colors
     */
    getAllRaw(productId) {
        const url = this.buildUrlWithParams(undefined, { productId });
        return this.http.get(url);
    }
}
ProductColorService.DEFAULT_SERVICE_PATH = 'products';
ProductColorService.BASE_PATH = 'api/product-colors';
//# sourceMappingURL=ProductColorService.js.map